import {
    Component, Input, OnInit
} from '@angular/core';
import { HttpService } from '../../services/http.service';
import { getWindow } from 'ssr-window';
import { CfAlertService } from '@crediblefinance/credible-ui';
import { OnboardingService } from '../onboarding.service';

@Component({
    selector: 'app-airdrop-buy-node',
    templateUrl: './airdrop-buy-node.component.html',
    styleUrls: [ './airdrop-buy-node.component.scss' ]
})
export class AirdropBuyNodeComponent implements OnInit {
    @Input() task = {
        id: '',
        title: '',
        desc: '',
        icon: '',
        status: 'Pending',
        reward: 0,
        multiplier: false,
        redirect_url: '',
        cta: '',
        coming_soon: false
    };

    constructor(public httpService: HttpService,
        private cfAlertService: CfAlertService,
        private onboardingService: OnboardingService
    ) {
        this.window = getWindow();
    }

    window: Window;

    generate_credit_score_loading: boolean = false;
    share_credit_score_loading: boolean = false;
    credit_score: any = {};
    progress: number = 0;

    ngOnInit(): void {
        this.attachSocketEvents();
    }

    attachSocketEvents() {

    }

    redirectToGenesis() {
        this.window.open(this.task.redirect_url, '_blank');
    }
}
